<script setup lang="ts">
  import { customerPage } from '@/cypaths';
  import type { VueComponentPropsBase } from '@/types';

  type PageContentClasses = 'headerWrapper' | 'headerContent' | 'content';

  defineOptions({
    name: 'PageContent',
    inheritAttrs: false,
  });

  const {
    classes = {},
    title = '',
    narrowHeader = false,
  } = defineProps<Partial<VueComponentPropsBase<PageContentClasses>> & {
    title?: string;
    isStatusBoxOpened?: boolean;
    narrowHeader?: boolean;
  }>();
</script>

<template>
  <div
    class="page-content grid h-full md:pb-8 print:block!"
    :class="[$attrs.class, classes.wrapper, title || $slots.header ? 'grid-rows-[min-content_1fr]' : 'grid-rows-[1fr]']"
    :data-cy="$attrs['data-cy']"
  >
    <div
      v-if="title || $slots.header"
      data-testid="page-content-header"
      :data-cy="customerPage.CONTENT_HEADER"
      class="grid grid-flow-row grid-rows-[min-content] bg-white"
      :class="[classes.headerWrapper, {'print:hidden': !$slots.header}]"
    >
      <div
        v-if="$slots.navigation"
        data-testid="page-content__navigation"
        class="print:hidden!"
      >
        <slot name="navigation" />
      </div>
      <div
        data-testid="page-content-header-content"
        class="-order-1 flex flex-col bg-white px-5 md:px-0 md:text-center"
        :class="[
          classes.headerContent,
          narrowHeader || isStatusBoxOpened ? 'md:pt-8' : 'md:pt-14',
          narrowHeader ? 'md:pb-8 gap-4 py-4' : 'md:pb-14 gap-8 pb-6 pt-4',
        ]"
      >
        <slot name="header">
          <h1
            v-if="title"
            class="md:container"
          >
            {{ title }}
          </h1>
        </slot>
      </div>
    </div>
    <div
      :data-cy="customerPage.CONTENT"
      data-testid="page-content__content"
      class="grid h-full min-h-[8rem] relative print:block!"
      :class="classes.content"
    >
      <slot />
    </div>
  </div>
</template>
